import { render, staticRenderFns } from "./InputFormDataParentView.vue?vue&type=template&id=1f74d4ab&"
import script from "./InputFormDataParentView.vue?vue&type=script&lang=js&"
export * from "./InputFormDataParentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports